import axios from 'axios';
import { toast } from 'react-toastify';

// Set base URL - using 5001 for local development
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// API Service Functions
export const authAPI = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  logout: () => api.post('/api/auth/logout'),
  getProfile: () => api.get('/api/auth/me'),
  changePassword: (data) => api.post('/api/auth/change-password', data)
};

export const clientsAPI = {
  getAll: (params) => api.get('/api/clients', { params }),
  getOne: (id) => api.get(`/api/clients/${id}`),
  create: (data) => api.post('/api/clients', data),
  update: (id, data) => api.put(`/api/clients/${id}`, data),
  delete: (id) => api.delete(`/api/clients/${id}`)
};

export const serviceCallsAPI = {
  getAll: (params) => api.get('/api/service-calls', { params }),
  getOne: (id) => api.get(`/api/service-calls/${id}`),
  getToday: () => api.get('/api/service-calls/today'),
  getCalendar: (month, year) => api.get('/api/service-calls/calendar', { params: { month, year } }),
  create: (data) => api.post('/api/service-calls', data),
  update: (id, data) => api.put(`/api/service-calls/${id}`, data),
  delete: (id) => api.delete(`/api/service-calls/${id}`)
};

export const invoicesAPI = {
  getAll: (params) => api.get('/api/invoices', { params }),
  getOne: (id) => api.get(`/api/invoices/${id}`),
  create: (data) => api.post('/api/invoices', data),
  createFromServiceCall: (serviceCallId, data) =>
    api.post(`/api/invoices/from-service-call/${serviceCallId}`, data),
  updateStatus: (id, status) => api.patch(`/api/invoices/${id}/status`, { status }),
  update: (id, data) => api.put(`/api/invoices/${id}`, data),
  delete: (id) => api.delete(`/api/invoices/${id}`)
};

export const usersAPI = {
  getAll: () => api.get('/api/users'),
  getOne: (id) => api.get(`/api/users/${id}`),
  create: (data) => api.post('/api/users', data),
  update: (id, data) => api.put(`/api/users/${id}`, data),
  delete: (id) => api.delete(`/api/users/${id}`)
};

export const dashboardAPI = {
  getStats: (params) => api.get('/api/dashboard/stats', { params })
};
